export const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';